const appName = 'tc'

const reduxAction = (sliceName) => (actionName) => {
  return `${appName}/${sliceName}/${actionName}`;
}

export default reduxAction;